define('cdo_imagezoom_imagezoom.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cdo_imagezoom_imagezoom', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n\n\n";
},"useData":true}, 'extensions/CDO/ImageZoom/1.0.0/', 'extensions/CDO/ImageZoom/1.0.0/', Handlebars);
});